import { FC } from 'react';
import * as React from 'react';

type EnterpriseLogoProps = {
  isSelected?: boolean;
};

const EnterpriseLogo: FC<React.PropsWithChildren<EnterpriseLogoProps>> = ({
  isSelected,
}) => {
  return (
    <svg
      viewBox="0 0 170 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-current transition-all"
      css={`
        color: ${isSelected ? 'var(--color-primary-light-400)' : '#b7bad5'};
        width: 101px;
        height: fit-content;

        @media (min-width: 768px) {
          width: 169px;
        }
        @media (min-width: 1024px) {
          width: 170px;
        }
      `}
    >
      <g
        clipPath="url(#a)"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M114.998 6.999h-82v104h82v-104Z" fill="#fff" />
        <path
          d="M154.998 110.999h-32v-66.54l32-13.46v80ZM106.998 2.999h-65v4h65v-4Z"
          fill="null"
        />
        <path d="M32.998 17.999h82M32.998 64.999h82" />
        <path
          d="M136.998 50.999h-4v6h4v-6ZM146.998 50.999h-4v6h4v-6ZM136.998 65.999h-4v6h4v-6ZM146.998 65.999h-4v6h4v-6Z"
          fill="#fff"
        />
        <path
          d="M50.998 71.999h-5v10h5v-10ZM67.998 71.999h-5v10h5v-10ZM50.998 87.999h-5v11h5v-11ZM67.998 87.999h-5v11h5v-11Z"
          fill="null"
        />
        <path d="M140.998 77.999h-49v33h49v-33Z" fill="#fff" />
        <path
          d="M129.998 90.999v-4h-27v4h27ZM129.998 101.999v-3h-27v3h27Z"
          fill="null"
        />
        <path d="m85.998 17.999-26 22M113.998 42.999l-27 22M88.998 24.999l-37 32" />
        <path
          d="M21.909 52.999v25.778h-5.911v32.222h17v-58h-11.09Z"
          fill="null"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(.334 -.001)"
            d="M0 0h169.332v110.001H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EnterpriseLogo;
